import {OneClickLCA} from './oneClickLCA';

export const oneClickLCA = new OneClickLCA();
